export default {"src":"/_next/static/media/linkedin-logo.462d5025.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};